import { Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { OrderService } from "../../../Services/order.service";
import { WiSnackBarService } from "../../../Services/wi-snackBar.service";
import { OrderConfirmationState } from "../buy-now-page/buy-now-page.component";

/**
 * "Commande envoyée" page displayed after a guest order created from the buy-now page.
 */
@Component({
  selector: "app-order-confirmation-page",
  templateUrl: "./order-confirmation-page.component.html",
  standalone: false,
})
export class OrderConfirmationPageComponent implements OnInit {
  orderId!: number;
  clientPhoneNumber?: string;
  isVirtual: boolean = false;
  storePhoneNumber: string = "0770 61 77 16";

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private route: ActivatedRoute,
    private router: Router,
    private orderService: OrderService,
    private wiSnackBarService: WiSnackBarService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    // the confirmation is only known to the visitor's browser (history.state): nothing to render on the server
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.orderId = Number(this.route.snapshot.paramMap.get("orderId"));
    // the state is only available when coming from the buy-now page
    const state = history.state as Partial<OrderConfirmationState>;
    if (!this.orderId || !state?.phoneNumber) {
      this.router.navigate(["/home"]);
      return;
    }
    this.clientPhoneNumber = state.phoneNumber;
    this.isVirtual = !!state.isVirtual;
  }

  /**
   * Downloads the guest order's purchase order (allowed for the session that created it).
   * @method downloadPurchaseOrder
   */
  downloadPurchaseOrder(): void {
    this.orderService.downloadGuestOrderBill(this.orderId).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = this.translate.instant("shared.orderBillFileName") + " " + this.orderId + ".pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.wiSnackBarService.openSnackBar(
          this.translate.instant("productsPage.snackbar.purchaseOrderDownloadError"),
          this.translate.instant("services.snackbar.close"),
          "error-snackbar",
        );
      },
    });
  }
}
